import { defineStore, storeToRefs } from "pinia";
import { ref, computed } from "vue";
import handleError from "@utils/composables/handleError";
import { useSurveyProfilesStore } from "@stores/survey/surveyProfiles";
import useMyFetch from "@stores/useMyFetch";
import { getClientId } from "@utils/clientId";
import { captureEvent } from "@/lib/analytics";

export const useProfileEditStore = defineStore("profileEdit", () => {
  // imported stores
  const surveyProfilesStore = useSurveyProfilesStore();
  const { surveyProfiles, selectedProfile, noProfileExist, countryOptions, selectedProfileIndex } =
    storeToRefs(surveyProfilesStore);

  const isLoagingGenerateDescription = ref(false);

  const currentProfile = computed(() => selectedProfile.value || {});
  const currentProfileErrors = computed(() => surveyProfiles.value[selectedProfileIndex.value].errors);

  const updateProfileCountry = (value) => (currentProfile.value.country = value);
  const updateProfileLanguage = (value) => (currentProfile.value.language = value);

  const nameIsUsed = (name) => {
    const names = surveyProfiles.value
      .filter((p) => p.token != selectedProfile.value.token) // do not compare with selected profile
      .map((p) => p.name.toLowerCase());
    return names.includes(name.toLowerCase());
  };

  const generateDescription = async () => {
    const other_descriptions = surveyProfiles.value.map((profile) => {
      if (profile.token != selectedProfile.value.token) {
        return profile.description;
      }
    });

    isLoagingGenerateDescription.value = true;

    try {
      const { response } = await useMyFetch(`/fake_respondent_profiles/${currentProfile.value.token}/generate_description`)
        .post({
          survey_id: currentProfile.value.survey_id,
          other_descriptions: other_descriptions,
          profile_token: currentProfile.value.token,
          client_id: getClientId(),
        })
        .json();

      if (response.value.ok) {
        captureEvent("fake_respondent_description_generated", { profile_token: currentProfile.value.token });
      }
    } catch (err) {
      handleError(err);
    }
  };

  const adsChannelHandlers = (cable, surveyToken) => {
    return {
      connected: subscribeToChannel(cable, surveyToken),
      rejected: () => console.log("rejected"),
      received: handleReceivedMessage,
    };
  };

  const subscribeToChannel = (cable, surveyToken) => () => {
    cable.perform({
      channel: "ProfilesDescriptionChannel",
      action: "subscribe",
      data: { survey_id: surveyToken },
    });
  };

  const handleReceivedMessage = (message) => {
    if (message?.type !== "ProfilesDescription") return;

    isLoagingGenerateDescription.value = false;

    if (message?.body?.error) {
      handleError(message.body.error);
      return;
    }

    if (!message?.body?.response) return;

    const { token } = message;
    const { description } = message.body.response;

    const profile = surveyProfiles.value.find((p) => p.token === token);
    profile.description = description;
  };

  return {
    currentProfile,
    currentProfileErrors,
    noProfileExist,
    countryOptions,
    updateProfileCountry,
    updateProfileLanguage,
    nameIsUsed,
    generateDescription,
    adsChannelHandlers,
    isLoagingGenerateDescription,
  };
});
